function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M486.82 21.213L465.607 0l-42.768 42.768H238.991L0 281.759 205.061 486.82l238.992-238.991V63.98l42.767-42.767zm-72.767 214.19L205.061 444.394 42.427 281.759 251.418 72.768h141.421l-40.097 40.097c-14.56-6.167-32.029-3.326-43.898 8.543-15.621 15.621-15.621 40.948 0 56.569 15.621 15.621 40.948 15.621 56.568 0 11.869-11.869 14.71-29.338 8.543-43.898l40.097-40.097v141.421z"
});

var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 486.82 486.82",
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgLabel;